const STORAGE_PREFIX = 'filtrosPesquisa_'

export function saveFilters(key, data) {
    try {
        sessionStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify(data))
    } catch (e) {
        return null;
    }
}

export function loadFilters(key) {
    try {
        const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${key}`);
        return raw ? JSON.parse(raw) : null
    } catch (e) {
        return null;
    }
}

export function clearFilters(key) {
    try {
        sessionStorage.removeItem(`${STORAGE_PREFIX}${key}`)
    } catch (e) {
        return null;
    }
}